import { c as _c } from "react/compiler-runtime";
import { JoinNodes } from '@/globals/helpers/JoinNodes';
import { QuestionNumber, Answer, EditButton, NoAnswerInline } from '../AnsweredQuestionParts';
import { QuestionMethods } from '../questionMethods.types';
import { RenderedMatrixQuestion, MatrixGivenAnswer } from './matrixMethods.types';
import { useMemo } from 'react';
const getAnswersForEachColumn = ({
  question,
  givenAnswer
}: {
  question: RenderedMatrixQuestion;
  givenAnswer: MatrixGivenAnswer;
}) => {
  const rowTitles = question.columns.slice(1).map(column => {
    const rowsWithThisAnswer = givenAnswer.rows.filter(({
      columnId
    }) => columnId === column.id);
    if (rowsWithThisAnswer.length === 0) return undefined;
    const rowTitles = rowsWithThisAnswer.map(({
      rowId
    }) => question.rows.find(row => row.id === rowId)?.fullTitle).filter(rowTitle => rowTitle != null);
    if (rowTitles.length === 0) return undefined;
    return {
      columnTitle: column.title,
      rowTitles
    };
  }).filter(rowTitles => rowTitles != null);
  return rowTitles;
};
export const AnsweredQuestionMatrix: QuestionMethods<RenderedMatrixQuestion, MatrixGivenAnswer>['Answered'] = t0 => {
  const $ = _c(15);
  const {
    question,
    givenAnswer,
    onEdit
  } = t0;
  let t1;
  if ($[0] !== givenAnswer || $[1] !== question) {
    t1 = getAnswersForEachColumn({
      question,
      givenAnswer
    });
    $[0] = givenAnswer;
    $[1] = question;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const answersForEachColumn = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <QuestionNumber />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== answersForEachColumn) {
    t3 = <Answer>{answersForEachColumn.length > 0 ? <JoinNodes elements={answersForEachColumn.map(_temp)} separator="; " /> : <NoAnswerInline />}</Answer>;
    $[4] = answersForEachColumn;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onEdit || $[7] !== question.id) {
    t4 = () => onEdit(question.id);
    $[6] = onEdit;
    $[7] = question.id;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== question.title || $[10] !== t4) {
    t5 = <EditButton onClick={t4} questionTitle={question.title} />;
    $[9] = question.title;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t5) {
    t6 = <>{t2}{t3}{t5}</>;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
function _temp(t0) {
  const {
    columnTitle,
    rowTitles
  } = t0;
  return <>{columnTitle}{": "}<JoinNodes elements={rowTitles} separator=", " /></>;
}